import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { useThemeContext } from '../../contexts';

interface ArrowRightIconProps {
  iconWidth?: number;
  iconHeight?: number;
  color?: string;
}

/**
 * @description Arrow right icon component
 * @param {ArrowRightIconProps} { iconWidth, iconHeight, color }
 * @return {React.FC}
 */
const ArrowRightIcon: React.FC<ArrowRightIconProps> = ({
  iconWidth = 24,
  iconHeight = 24,
  color
}) => {
  const { theme } = useThemeContext();
  const iconColor = color || theme.textPrimary;

  return (
    <Svg
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth={1.5}
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round">
      <Path d="M4 12h16M13 5l7 7-7 7" strokeWidth={1.5} vectorEffect="non-scaling-stroke" />
    </Svg>
  );
};

export default ArrowRightIcon;
